import React from "react";
import styled from "styled-components";

import GenericModal from "../generic_modal";

// Modal de boas-vindas exibido UMA vez na vida do admin novo no painel.
// Aceitar -> tour_started=true (ProgressCard aparece em sequencia).
// Pular   -> tour_started=false (PageHints continuam disponiveis via switch).

export default function WelcomeModal({ open, onAccept, onSkip, userName }) {
    return (
        <GenericModal
            open={open}
            onClose={onSkip}
            title="Tour guiado"
            width={520}
            showClose={true}
        >
            <Greeting>
                {userName ? `Olá, ${userName}.` : "Boas-vindas ao Zag"}
            </Greeting>
            <Body>
                Conheça tudo o que o Zag oferece. Para isso, preparamos um
                tour rápido para te ajudar a conhecer as configurações
                essenciais do painel: Centro de custo, Categorias, Gestão de
                usuários, Cartão corporativo, Despesas por Quilometragem e
                Gestão de Créditos.
            </Body>
            <Body>
                Você pode começar agora ou pular e ativar depois pelo menu
                lateral.
            </Body>
            <Actions>
                <SkipButton type="button" onClick={onSkip}>
                    Pular
                </SkipButton>
                <PrimaryButton type="button" onClick={onAccept}>
                    Começar tour
                </PrimaryButton>
            </Actions>
        </GenericModal>
    );
}

const Greeting = styled.h3`
    font-family: "Montserrat", sans-serif;
    font-weight: 600;
    font-size: 18px;
    color: #181122;
    margin: 0 0 12px 0;
`;

const Body = styled.p`
    font-family: "Montserrat", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #181122;
    margin: 0 0 12px 0;
`;

const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 16px;
`;

const PrimaryButton = styled.button`
    background: #57c4c2;
    color: #ffffff;
    border: none;
    border-radius: 4px;
    padding: 10px 20px;
    font-family: "Montserrat", sans-serif;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.2s;
    &:hover {
        background: #4ba09b;
    }
`;

const SkipButton = styled.button`
    background: transparent;
    color: #181122;
    border: 1px solid #908080;
    border-radius: 4px;
    padding: 10px 20px;
    font-family: "Montserrat", sans-serif;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.2s;
    &:hover {
        background: rgba(0, 0, 0, 0.05);
    }
`;
